export default __webpack_public_path__ + "static/media/5.44ae9e82.png";